module.exports = __webpack_public_path__ + "static/002.thumb-2f4ba52d8bf4a31ff6a13b0be5f8ea7b.jpg";